// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.d9f44c20d',
  revision: 'd9f44c20d',
  branch: 'develop',
  date: 'Mon, 01 Jun 2026 15:29:27 GMT'
};